import { LocationType } from 'src/types/graphql'

/**
 * Code-identical mirror of spotme-server/src/constants/pillarBoundaries.ts
 * (the backend file carries the full rationale comments; the exported
 * values must match EXACTLY). Any change requires the same change in both
 * repos in the same PR. Cross-repo sync table: see root CLAUDE.md.
 */
/**
 * The location types that make a space a VEHICLE space — the single authority
 * for "does this belong on the parking pillar?". Consumed by
 * `derivePillarFromDraft` and `deriveCanStoreVehicle` in `AddPostFlow/`.
 *
 * `GARAGE` is a legacy alias: it is not selectable in the AddPostFlow picker
 * and no active configuration carries it since the 2026-08-24 reclassification,
 * but a draft or restored record still has to land on the right pillar. The
 * backend file carries the full rationale (four hand-maintained lists, each
 * missing a different member, and what that cost in production).
 */
export const VEHICLE_LOCATION_TYPES: readonly LocationType[] = [
  LocationType.Parking,
  LocationType.Land,
  LocationType.Garage
] as const

/** True when `locationType` puts the space on the parking pillar. */
export const isVehicleLocationType = (
  locationType: LocationType | null | undefined
): boolean => !!locationType && VEHICLE_LOCATION_TYPES.includes(locationType)

export const PILLAR_BOUNDARIES = {
  selfStorageMaxSqm: 50,
  warehouseMaxSqm: 3000
} as const
